import React, {PropTypes} from 'react';
import classNames from 'classnames';
import moment from 'moment';
import {formatCurrency} from 'shared/util/formatCurrency';
import DisplayIf from 'shared/DisplayIf.jsx';
Number.prototype.formatCurrency = formatCurrency;

const OrderReviewSquadItem = ({
  id,
  eventName,
  startDateTime,
  quantity,  
  available,
  adminAvailable,
  eventPrice,
  eventAddOnFees,
  eventTotalPrice,
  name,
  price,
  qtyNotEditable,
  onRemoveSquadItem,
  onRemoveVirtualEvent,
  onSquadFeesClick,
  onQuantityChange,
  onVirtualEventQuantityChange
}) => (
  <div>
  { eventAddOnFees ?
    <div className="list-group-item-labeled">
        <div
          style={{width: 120}}
          className="list-group-item-labeled-child"
        >
          <span>{'Event Name'}</span>
          <span>{eventName}</span>
        </div>

        <div
          style={{width: 150}}
          className="list-group-item-labeled-child"
        >
          <span>{'Date'}</span>
          <span>{moment.parseZone(startDateTime).format('ddd, MMM DD YYYY')}</span>
        </div>

        <div
          style={{width: 80}}
          className="list-group-item-labeled-child"
        >
          <span>{'Time'}</span>
          <span>{moment.parseZone(startDateTime).format('hh:mm A')}</span>
        </div>

        <div
          style={{width: 80}}
          className="list-group-item-labeled-child"
        >
          <span>{'Quantity'}</span>
          <input
            style={{width: 80}}
            disabled={!available && !adminAvailable || qtyNotEditable}
            type="number"
            min="0"
            step="1"
            max={adminAvailable ? adminAvailable : available}
            value={quantity}
            onChange={event => onQuantityChange({
              squadId: id,
              inputValue: event.target.value,
              max: adminAvailable ? adminAvailable : available
            })}
          />
        </div>

        <div
        className={classNames(
          {'list-group-item-labeled-child': !eventAddOnFees.length},
          {'list-group-item-labeled-child-clickable': eventAddOnFees.length}
        )}
          style={{width: 80}}
          onClick={eventAddOnFees.length
            ? () => onSquadFeesClick(eventPrice, eventAddOnFees)
            : () => {}}
        >
          <span>{'Unit Price ($)'}</span>
          <span>{eventTotalPrice.formatCurrency(2)}</span>
        </div>

        <div className="list-group-item-labeled-child"
          style={{width: 80}}>
          <span>{'Item Total ($)'}</span>
          <span>{(eventTotalPrice*quantity).formatCurrency(2)}</span>
        </div>  
        <DisplayIf condition={!qtyNotEditable}>
        <div
          style={{width: 80, marginTop: 8}}
          className="list-group-item-labeled-child"
        >
          <button
            className="btn btn-link"
            type="button"
            onClick={() => onRemoveSquadItem(id)}
          ><i className="fa fa-shopping-cart" /> {'Remove'}</button>
        </div>
        </DisplayIf>
      </div>
  : <div className="list-group-subitem-container">
      <div
        style={{width: 120}}
        className="list-group-item-labeled-child"
      />
      <div
        style={{width: 918}}
        className="list-group-subitem-labeled"
      >
        <div
          style={{width: 150}}
          className="list-group-item-labeled-child"
        >
          <span>{'Virtual Event'}</span>
          <span>{name}</span>
        </div>

        <div
          style={{width: 80}}
          className="list-group-item-labeled-child"
        />

        <div
          style={{width: 80}}
          className="list-group-item-labeled-child"
        >
          <span>{'Quantity'}</span>
          <input
            style={{width: 80}}
            disabled={qtyNotEditable}
            value={quantity}
            type="number"
            min="0"
            step="1"
            onChange={event => onVirtualEventQuantityChange({
              virtualEventId: id,
              inputValue: event.target.value
            })} />
        </div>

        <div
          className="list-group-item-labeled-child"
          style={{width: 80}}
        >
          <span>{'Unit Price ($)'}</span>
          <span>{price.formatCurrency(2)}</span>
        </div>

        <div
          className="list-group-item-labeled-child"
          style={{width: 80}}
        >
          <span>{'Item Total ($)'}</span>
          <span>{(price*quantity).formatCurrency(2)}</span>
        </div>
        <DisplayIf condition={!qtyNotEditable}>
        <div
          style={{width: 80}}
          className="list-group-item-labeled-child"
        >
          
          <button
            className="btn btn-link"
            type="button"
            onClick={() => onRemoveVirtualEvent(id)}
          ><i className="fa fa-shopping-cart" /> {'Remove'}</button>
        </div>
        </DisplayIf>
      </div>
    </div>
  }
  </div>
);

OrderReviewSquadItem.propTypes = {
  id: PropTypes.string,
  eventName: PropTypes.string,
  startDateTime: PropTypes.string,
  quantity: PropTypes.number,
  available: PropTypes.number,
  adminAvailable: PropTypes.number,
  eventPrice: PropTypes.number,
  eventAddOnFees: PropTypes.arrayOf(PropTypes.object),
  eventTotalPrice: PropTypes.number,
  name: PropTypes.string,
  price: PropTypes.number,
  qtyNotEditable: PropTypes.bool,
  onRemoveSquadItem: PropTypes.func,
  onRemoveVirtualEvent: PropTypes.func,
  onSquadFeesClick: PropTypes.func,
  onQuantityChange: PropTypes.func,
  onVirtualEventQuantityChange: PropTypes.func
};

OrderReviewSquadItem.defaultProps = {
  eventTotalPrice: 0,
  quantity: 0
};

export default OrderReviewSquadItem;



// WEBPACK FOOTER //
// ./src/features/shared/OrderReviewSquadItem.jsx